import { ProfileAdapterInteface } from 'src/adapter/ProfileAdapterInterface';
import { ProfileGetAttributes } from 'src/models/ProfileModel';
import { api } from 'boot/axios';
import { axiosErrorHandler } from 'src/error/handler/axiosErrorHandler';
export class AxiosProfileAdapter implements ProfileAdapterInteface {
  async getProfile(): Promise<ProfileGetAttributes> {
    try {
      const res = await api.get(`/profile`);
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
}
